// Base stylesheet needed for every page
import './scss/app.scss';

require('./scripts/cart');
require('./scripts/specs');
require('./scripts/filters');
